<template>
  <section class="lms3020-container">
    <div class="lms3020 white border-main shadow-dark">
      <Ul class="crumbs text-charcoal mb-2">
        <li><sym-link to="/">Home</sym-link></li>
        <li>
          <sym-link to="/regional-performance">Regional Performance</sym-link>
        </li>
        <li><sym-link :to="getStatsPagePath()">Statistics</sym-link></li>
        <li><span aria-current="page">Details</span></li>
      </Ul>

      <sym-card class="lams" headerClass="p-1 pl-2">
        <div slot="header" class="reg-stat justify-between align-items-center">
          <p class="reg-stat-title serif bold">Regional Statistics</p>

          <div class="control-container text-charcoal">
            <sym-combo
              v-model="regionId"
              :input-width="50"
              display-field="regionFullName"
              :datasource="regions"
              @changed="onRegionIdChanged"
            ></sym-combo>
            <sym-combo
              v-model="yearId"
              caption="Year"
              :caption-width="14"
              :input-width="48"
              display-field="yearId"
              :datasource="detailYears"
              @changed="onYearIdChanged"
              class="year-control"
            ></sym-combo>
          </div>
        </div>
      </sym-card>
      <sym-tabs
        id="tabs"
        v-model="activeTabIndex"
        @changed="onActiveTabIndexChanged"
      >
        <sym-tab title=" IVAS" icon="cube">
          <div class="table-scroll-wrapper">
            <sym-radio
              id="ivas-combo"
              plain
              v-model="optionId"
              captionClass="lg-1 bold"
              caption="IVAS"
              display-field="optionName"
              :datasource="ivasOptions"
              align="bottom"
              class="w-100 mb-3"
              inputBoxClass="px-1"
              @changed="onOptionIdChanged"
            ></sym-radio>
            <!-- <div class="date-container"></div> -->
            <div class="d-flex justify-end mb-2">
              <!-- <sym-date
                plain
                align="bottom"
                v-model="birthDate"
                @changing="onBirthDateChanging"
                @blur="onBirthDateChanging"
                class="date-picker"
              ></sym-date> -->
              <button class="success fw-23 shadow-dark  px-2" @click="onPrint">
                <i class="fa fa-print fa-fw fa-lg"></i> Print
              </button>
            </div>
            <!--   -->
            <div class="to-print" v-show="optionId === 1">
              <div class="chart-container-ivas-summary border-soft mb-3">
                <canvas
                  id="ivas-summary-chart"
                  class="p-2 chart-canvas"
                ></canvas>
              </div>

              <table class="sm-2 table-scroll-ivas-summary">
                <thead>
                  <!-- <tr class="whitesmoke text-charcoal text-center text-bold">
                    <td
                      class="bold"
                      :colspan="ivas.summary.submittedCounts.length + 2"
                    >
                      As of Date: {{ sym.dateInfo.systemDateDisplay }}
                    </td>
                  </tr> -->
                </thead>
                <thead>
                  <tr class="text-right text-charcoal">
                    <th class=""></th>
                    <th
                      v-for="(monthName, index) in ivas.summary.months"
                      :key="index"
                    >
                      {{ monthName }}
                    </th>
                    <th>Total</th>
                  </tr>
                </thead>

                <tbody class="text-charcoal table-body">
                  <tr
                    class="text-right aliceblue text-charcoal"
                    v-if="isCurrentYear"
                  >
                    <td class="text-left w-15 font-bold">
                      {{ yearId - 1 }} Residual
                    </td>
                    <!--PJN -->
                    <td
                      v-for="(_, index) in ivas.summary.months"
                      :key="index"
                    ></td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          ivas.summary.prevYear.inProcessTotal,
                          false
                        )
                      }}
                      <!-- {{
                        core.toIntegerFormat(
                          ivas.summary.prevYear.activeTotal +
                            ivas.summary.prevYear.pendingTotal,
                          false
                        )
                      }} -->
                    </td>
                  </tr>

                  <tr
                    class="text-right aliceblue text-charcoal"
                    v-if="isCurrentYear"
                  >
                    <td class="text-left">
                      <span class="ml-3 w-15">Active</span>
                    </td>
                    <td
                      v-for="(_, index) in ivas.summary.months"
                      :key="index"
                    ></td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          ivas.summary.prevYear.activeTotal,
                          false
                        )
                      }}
                    </td>
                  </tr>

                  <tr
                    class="text-right aliceblue text-charcoal"
                    v-if="isCurrentYear"
                  >
                    <td class="text-left">
                      <span class="ml-3">Pending</span>
                    </td>
                    <td
                      v-for="(_, index) in ivas.summary.months"
                      :key="index"
                    ></td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          ivas.summary.prevYear.pendingTotal,
                          false
                        )
                      }}
                    </td>
                  </tr>

                  <tr class="text-right">
                    <td class="text-left">Submitted</td>
                    <td
                      v-for="(val, index) in ivas.summary.submittedCounts"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(ivas.summary.submittedCounts),
                          false
                        )
                      }}
                    </td>
                  </tr>

                  <tr class="text-right">
                    <td class="text-left">Approved</td>
                    <td
                      v-for="(val, index) in ivas.summary.approvedCounts"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(ivas.summary.approvedCounts),
                          false
                        )
                      }}
                    </td>
                  </tr>
                  <tr class="text-right mintcream">
                    <td class="text-left">
                      <span class="ml-3">Residual</span>
                    </td>
                    <td
                      v-for="(val, index) in ivas.summary.approvedResidualCount"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>

                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(ivas.summary.approvedResidualCount),
                          false
                        )
                      }}
                    </td>
                  </tr>
                  <tr class="text-right mintcream">
                    <td class="text-left">
                      <span class="ml-3">New Submission</span>
                    </td>
                    <td
                      v-for="(val, index) in ivas.summary.approveNewSubmission"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>

                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(ivas.summary.approveNewSubmission),
                          false
                        )
                      }}
                    </td>
                  </tr>

                  <tr class="text-right">
                    <td class="text-left">Rejected</td>
                    <td
                      v-for="(val, index) in ivas.summary.rejectedCounts"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(ivas.summary.rejectedCounts),
                          false
                        )
                      }}
                    </td>
                  </tr>

                  <!-- JENON -->

                  <!-- <tr class="text-right mintcream text-charcoal" v-if="isCurrentYear">
                 <td class="text-left">{{ currentYear }} Active</td>
                 <td v-for="(val, index) in ivas.summary.thisYear.activeCounts" :key="index">{{ core.toIntegerFormat(val, false) }}</td>
                 <td>{{ core.toIntegerFormat(core.sumArray(ivas.summary.thisYear.activeCounts), false) }}</td>
                 <td></td>
                 </tr> -->

                  <tr class="text-right" v-if="isCurrentYear">
                    <td class="text-left">In-Process</td>
                    <td
                      v-for="(val, index) in ivas.summary.thisYear
                        .inProcessCounts"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>
                    <td>
                      <!-- {{
                        core.toIntegerFormat(
                          0,// core.sumArray(ivas.summary.thisYear.inProcessCounts),
                          false
                        )
                      }} -->
                    </td>
                    <!-- <td></td> -->
                  </tr>

                  <tr
                    class="text-right mintcream text-charcoal"
                    v-if="isCurrentYear"
                  >
                    <td class="text-left">
                      <span class="ml-3">Active</span>
                    </td>
                    <td
                      v-for="(val, index) in ivas.summary.thisYear.activeCounts"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>
                    <td>
                      <!-- {{
                        core.toIntegerFormat(
                          0,//core.sumArray(ivas.summary.thisYear.activeCounts),
                          false
                        )
                      }} -->
                    </td>
                  </tr>
                  <tr
                    class="text-right mintcream text-charcoal"
                    v-if="isCurrentYear"
                  >
                    <td class="text-left">
                      <span class="ml-3">Pending</span>
                    </td>
                    <td
                      v-for="(val, index) in ivas.summary.thisYear
                        .pendingCounts"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>
                    <td>
                      <!-- {{
                        core.toIntegerFormat(
                          0,//core.sumArray(ivas.summary.thisYear.pendingCounts),
                          false
                        )
                      }} -->
                    </td>
                    <!-- <td></td> -->
                  </tr>
                  <!--
                 <tr class="text-right mintcream text-charcoal" v-if="isCurrentYear">
                     <td class="text-left"><span class="ml-3">Cancelled</span></td>
                      <td v-for="(val, index) in ivas.summary.thisYear.cancelledCounts" :key="index">{{ core.toIntegerFormat(val, false) }}</td>
                    <td></td>
                 </tr> -->
                </tbody>
              </table>

              <!--nasa summary ito--->
              <div class="text-center text-charcoal">
                <p class="lg-2 bold mb-0">
                  Approved {{ yearId }} - {{ approvedSurveysChartTitle }}
                </p>
                <p class="display-10 bold">{{ regionName }}</p>
              </div>
              <div class="chart-container mb-3">
                <div class="border-soft">
                  <canvas
                    id="simple-survey-chart"
                    class="p-2 chart-canvas"
                  ></canvas>
                </div>

                <div class="border-soft">
                  <canvas
                    id="complex-survey-chart"
                    class="p-2 chart-canvas"
                  ></canvas>
                </div>
              </div>
              <table class="sm-2 table-scroll-ivas-approved">
                <thead class="text-charcoal">
                  <tr class="text-center">
                    <th rowspan="2" class="align-bottom text-left">Month</th>
                    <th colspan="2">1-20 days</th>
                    <th colspan="2">21-40 days</th>
                    <th colspan="2">Over 40 Days</th>
                    <th rowspan="2" class="w-10 align-bottom text-right">
                      Total
                    </th>
                  </tr>
                  <tr class="text-right">
                    <th>Simple</th>
                    <th>Complex</th>
                    <th>Simple</th>
                    <th>Complex</th>
                    <th>Simple</th>
                    <th>Complex</th>
                  </tr>
                </thead>

                <tbody class="text-charcoal" true>
                  <tr
                    v-for="(data, index) in ivas.approved.table"
                    :key="index"
                    class="text-right"
                  >
                    <td class="text-left">
                      {{ getMonthName(data.periodId, true) }}
                    </td>
                    <td>
                      {{ core.toIntegerFormat(data.s1To15Count, false) }}
                    </td>
                    <td>
                      {{ core.toIntegerFormat(data.c1To15Count, false) }}
                    </td>

                    <td>
                      {{ core.toIntegerFormat(data.s16To66Count, false) }}
                    </td>
                    <td>
                      {{ core.toIntegerFormat(data.c16To66Count, false) }}
                    </td>

                    <td>
                      {{ core.toIntegerFormat(data.sOver3MonCount, false) }}
                    </td>
                    <td>
                      {{ core.toIntegerFormat(data.cOver3MonCount, false) }}
                    </td>

                    <td>
                      {{ core.toIntegerFormat(data.periodTotal, false) }}
                    </td>
                  </tr>

                  <tr class="text-right">
                    <td class="bold text-left">Total</td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(ivas.approved.s1To15Counts),
                          false
                        )
                      }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(ivas.approved.c1To15Counts),
                          false
                        )
                      }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(ivas.approved.s16To66Counts),
                          false
                        )
                      }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(ivas.approved.c16To66Counts),
                          false
                        )
                      }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(ivas.approved.sOver3MonCounts),
                          false
                        )
                      }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(ivas.approved.cOver3MonCounts),
                          false
                        )
                      }}
                    </td>
                    <td class="bold">
                      {{
                        core.toIntegerFormat(
                          core.sumArray(ivas.approved.periodTotals),
                          false
                        )
                      }}
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr class="text-right whitesmoke text-charcoal">
                    <td :colspan="8">
                      Date: {{ sym.dateInfo.systemDateDisplay }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <div class="to-print" v-show="isIvasApprovedSurveysOption">
            <div class="text-center text-charcoal">
              <p class="lg-2 bold mb-0">
                Approved {{ yearId }} - {{ approvedSurveysChartTitle }}
              </p>
              <p class="display-10 bold">{{ regionName }}</p>
            </div>

            <div class="chart-container mb-3">
              <div class="border-soft">
                <canvas
                  id="simple-survey-chart1"
                  class="p-2 chart-canvas"
                ></canvas>
              </div>

              <div class="border-soft">
                <canvas
                  id="complex-survey-chart1"
                  class="p-2 chart-canvas"
                ></canvas>
              </div>
            </div>

            <table class="sm-2 table-scroll-ivas-approved">
              <thead class="text-charcoal">
                <tr class="text-center">
                  <th rowspan="2" class="align-bottom text-left">Month</th>
                  <th colspan="2">1-20 days</th>
                  <th colspan="2">21-40 days</th>
                  <th colspan="2">Over 40 Days</th>
                  <th rowspan="2" class="w-10 align-bottom text-right">
                    Total
                  </th>
                </tr>
                <tr class="text-right">
                  <th>Simple</th>
                  <th>Complex</th>
                  <th>Simple</th>
                  <th>Complex</th>
                  <th>Simple</th>
                  <th>Complex</th>
                </tr>
              </thead>

              <tbody class="text-charcoal">
                <tr
                  v-for="(data, index) in ivas.approved.table"
                  :key="index"
                  class="text-right"
                >
                  <td class="text-left">
                    {{ getMonthName(data.periodId, true) }}
                  </td>
                  <td>
                    {{ core.toIntegerFormat(data.s1To15Count, false) }}
                  </td>
                  <td>
                    {{ core.toIntegerFormat(data.c1To15Count, false) }}
                  </td>

                  <td>
                    {{ core.toIntegerFormat(data.s16To66Count, false) }}
                  </td>
                  <td>
                    {{ core.toIntegerFormat(data.c16To66Count, false) }}
                  </td>

                  <td>
                    {{ core.toIntegerFormat(data.sOver3MonCount, false) }}
                  </td>
                  <td>
                    {{ core.toIntegerFormat(data.cOver3MonCount, false) }}
                  </td>

                  <td>
                    {{ core.toIntegerFormat(data.periodTotal, false) }}
                  </td>
                </tr>

                <tr class="text-right">
                  <td class="bold text-left">Total</td>
                  <td>
                    {{
                      core.toIntegerFormat(
                        core.sumArray(ivas.approved.s1To15Counts),
                        false
                      )
                    }}
                  </td>
                  <td>
                    {{
                      core.toIntegerFormat(
                        core.sumArray(ivas.approved.c1To15Counts),
                        false
                      )
                    }}
                  </td>
                  <td>
                    {{
                      core.toIntegerFormat(
                        core.sumArray(ivas.approved.s16To66Counts),
                        false
                      )
                    }}
                  </td>
                  <td>
                    {{
                      core.toIntegerFormat(
                        core.sumArray(ivas.approved.c16To66Counts),
                        false
                      )
                    }}
                  </td>
                  <td>
                    {{
                      core.toIntegerFormat(
                        core.sumArray(ivas.approved.sOver3MonCounts),
                        false
                      )
                    }}
                  </td>
                  <td>
                    {{
                      core.toIntegerFormat(
                        core.sumArray(ivas.approved.cOver3MonCounts),
                        false
                      )
                    }}
                  </td>
                  <td class="bold">
                    {{
                      core.toIntegerFormat(
                        core.sumArray(ivas.approved.periodTotals),
                        false
                      )
                    }}
                  </td>
                </tr>
              </tbody>

              <tfoot>
                <tr class="text-right whitesmoke text-charcoal">
                  <td :colspan="8">
                    Date: {{ sym.dateInfo.systemDateDisplay }}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </sym-tab>
        <!--
        <sym-radio
              id="pla-combo"
              vertical
              plain
              v-model="optionId"
              captionClass="lg-1 bold"
              caption="PLA"
              display-field="optionName"
              :datasource="plaOptions"
              align= "bottom"
              class="w-100 mb-3"
              inputBoxClass="px-1"
              @changed="onOptionIdChanged"
              v-show="plaOptions && plaOptions.length"
            ></sym-radio> -->
        <!-- <div class="table-scroll-wrapper" v-show="plaOptionId === 1"> -->

        <sym-tab title=" PLA" icon="copy">
          <div class="table-scroll-wrapper">
            <sym-radio
              id="PLA-combo"
              plain
              v-model="plaOptionId"
              captionClass="lg-1 bold"
              caption="PLA"
              display-field="optionName"
              :datasource="PLAOptions"
              align="bottom"
              class="w-100 mb-3"
              inputBoxClass="px-1"
              @changed="onOptionIdChanged"
            ></sym-radio>

            <!-- PLA SUMMARY -->

            <!-- JENON -->

            <div class="to-print" v-show="plaOptionId === 1">
              <div class="chart-container-pla-production border-soft mb-3 ">
                <canvas
                  id="pla-summary-chart"
                  class="p-2 chart-canvas"
                ></canvas>
              </div>

              <table class="sm-2 table-scroll-pla-production">
                <thead>
                  <tr class="text-right text-charcoal">
                    <th class="w-15"></th>
                    <th
                      v-for="(monthName, index) in plaSummary.months"
                      :key="index"
                    >
                      {{ monthName }}
                    </th>
                    <th>Total</th>
                  </tr>
                </thead>

                <tbody class="text-charcoal">
                  <tr class="text-right">
                    <td class="text-left">Submitted</td>
                    <td
                      v-for="(val, index) in plaSummary.submittedCounts"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(plaSummary.submittedCounts),
                          false
                        )
                      }}
                    </td>
                  </tr>

                  <tr class="text-right">
                    <td class="text-left">Approved</td>
                    <td
                      v-for="(val, index) in plaSummary.approvedCounts"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(plaSummary.approvedCounts),
                          false
                        )
                      }}
                    </td>
                  </tr>

                  <tr class="text-right">
                    <td class="text-left">
                      <span class="ml-3">New Submission</span>
                    </td>
                    <td
                      v-for="(val, index) in plaSummary.approveNewSubmission"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(plaSummary.approveNewSubmission),
                          false
                        )
                      }}
                    </td>
                  </tr>

                  <tr class="text-right">
                    <td class="text-left">
                      <span class="ml-3">Residual</span>
                    </td>
                    <td
                      v-for="(val, index) in plaSummary.approvedResidualCount"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(plaSummary.approvedResidualCount),
                          false
                        )
                      }}
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr class="text-right whitesmoke text-charcoal">
                    <td :colspan="plaSummary.submittedCounts.length + 2">
                      Date: {{ sym.dateInfo.systemDateDisplay }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <!-- PLA SUMMARY -->

            <div class="Pla-container text-charcoal">
              <sym-combo
                v-model="optionId"
                caption="--- Select PENRO ---"
                :caption-width="40"
                :input-width="58"
                display-field="optionName"
                :datasource="plaOptions"
                @changed="onOptionIdChanged"
              ></sym-combo>
            </div>

            <div class="to-print" v-show="showPenroStats">
              <div class="chart-container-pla-production border-soft mb-3 ">
                <canvas id="pla-chart" class="p-2 chart-canvas"></canvas>
              </div>

              <table class="sm-2 table-scroll-pla-production">
                <thead>
                  <tr class="text-right text-charcoal">
                    <th class="w-15"></th>
                    <th v-for="(monthName, index) in pla.months" :key="index">
                      {{ monthName }}
                    </th>
                    <th>Total</th>
                  </tr>
                </thead>

                <tbody class="text-charcoal">
                  <tr class="text-right">
                    <td class="text-left">Submitted</td>
                    <td
                      v-for="(val, index) in pla.submittedCounts"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(pla.submittedCounts),
                          false
                        )
                      }}
                    </td>
                  </tr>

                  <tr class="text-right">
                    <td class="text-left">Approved</td>
                    <td v-for="(val, index) in pla.approvedCounts" :key="index">
                      {{ core.toIntegerFormat(val, false) }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(pla.approvedCounts),
                          false
                        )
                      }}
                    </td>
                  </tr>

                  <tr class="text-right">
                    <td class="text-left">
                      <span class="ml-3">New Submission</span>
                    </td>
                    <td
                      v-for="(val, index) in pla.approveNewSubmission"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(pla.approveNewSubmission),
                          false
                        )
                      }}
                    </td>
                  </tr>

                  <tr class="text-right">
                    <td class="text-left">
                      <span class="ml-3">Residual</span>
                    </td>
                    <td
                      v-for="(val, index) in pla.approvedResidualCount"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(pla.approvedResidualCount),
                          false
                        )
                      }}
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr class="text-right whitesmoke text-charcoal">
                    <td :colspan="pla.submittedCounts.length + 2">
                      Date: {{ sym.dateInfo.systemDateDisplay }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="Pla-container text-charcoal">
              <sym-combo
                v-model="cenroOfficeId"
                caption="--- Select CENRO ---"
                :caption-width="40"
                :input-width="58"
                display-field="fieldOfficeName"
                :datasource="cenroOptions"
                @changed="onCenroOptionIdChanged"
                v-if="showCenroFlag"
              ></sym-combo>
            </div>

            <!-- JENON -->
            <div class="to-print" v-show="showCenroStats">
              <div class="chart-container-pla-production border-soft mb-3 ">
                <canvas id="cenro-chart" class="p-2 chart-canvas"></canvas>
              </div>

              <table class="sm-2 table-scroll-pla-production">
                <thead>
                  <tr class="text-right text-charcoal">
                    <th class="w-15"></th>
                    <th v-for="(monthName, index) in cenro.months" :key="index">
                      {{ monthName }}
                    </th>
                    <th>Total</th>
                  </tr>
                </thead>

                <tbody class="text-charcoal">
                  <tr class="text-right">
                    <td class="text-left">Submitted</td>
                    <td
                      v-for="(val, index) in cenro.submittedCounts"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(cenro.submittedCounts),
                          false
                        )
                      }}
                    </td>
                  </tr>

                  <tr class="text-right">
                    <td class="text-left">Approved</td>
                    <td
                      v-for="(val, index) in cenro.approvedCounts"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(cenro.approvedCounts),
                          false
                        )
                      }}
                    </td>
                  </tr>

                  <tr class="text-right">
                    <td class="text-left">
                      <span class="ml-3">New Submission</span>
                    </td>
                    <td
                      v-for="(val, index) in cenro.approveNewSubmission"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(cenro.approveNewSubmission),
                          false
                        )
                      }}
                    </td>
                  </tr>

                  <tr class="text-right">
                    <td class="text-left">
                      <span class="ml-3">Residual</span>
                    </td>
                    <td
                      v-for="(val, index) in cenro.approvedResidualCount"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(cenro.approvedResidualCount),
                          false
                        )
                      }}
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr class="text-right whitesmoke text-charcoal">
                    <td :colspan="cenro.submittedCounts.length + 2">
                      Date: {{ sym.dateInfo.systemDateDisplay }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <!-- <div class="PLA" v-show="showCenroStats">
              <div class="chart-container-pla-production border-soft mb-3 ">
                <canvas id="cenro-chart" class="p-2 chart-canvas"></canvas>
              </div>

              <table class="sm-2 table-scroll-pla-production">
                <thead>
                  <tr class="text-right text-charcoal">
                    <th class="w-15"></th>
                    <th v-for="(monthName, index) in cenro.months" :key="index">
                      {{ monthName }}
                    </th>
                    <th>Total</th>
                  </tr>
                </thead>

                <tbody class="text-charcoal">
                  <tr class="text-right">
                    <td class="text-left">Submitted</td>
                    <td
                      v-for="(val, index) in cenro.submittedCounts"
                      :key="index"
                    >
                      {{ core.toIntegerFormat(val, false) }}
                    </td>
                    <td>
                      {{
                        core.toIntegerFormat(
                          core.sumArray(cenro.submittedCounts),
                          false
                        )
                      }}
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr class="text-right whitesmoke text-charcoal">
                    <td :colspan="cenro.submittedCounts.length + 2">
                      Date: {{ sym.dateInfo.systemDateDisplay }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div> -->

            <!-- JENON -->
          </div>
        </sym-tab>
      </sym-tabs>
    </div>
  </section>
</template>

<script>
import * as lams from "../../js/lams";

import { get } from "../../js/http";

import { drawBarChart } from "../../js/graph";

import { drawLineChart } from "../../js/graph";

import PageBase from "../PageBase.vue";

export default {
  extends: PageBase,
  name: "lms3020",

  data() {
    return {
      regionId: 0,
      regionName: "Unknown",
      regions: [],
      charts: [],

      yearId: this.core.getCurrentYear(),
      detailYears: [],
      activeTabIndex: 0,
      currentYear: 0,
      prevYear: 0,
      cenroOptionId: "0",
      cenroOfficeId: 0,
      optionId: 1, // IVAS Summary
      plaOptionId: 1, // PLA
      ivasOptions: [],
      plaOptions: [],
      PLAOptions: [],
      cenroOptions: [],
      showCenroFlag: false,
      showPenroStats: false,
      fieldOfficeId: 0,
      penroTypeId: "",
      fieldOfficeName: "Unknown",
      cenroOfficeName: "Unknown",
      // isShowFilter: false,
      ivas: {
        summary: {
          months: [],
          submittedCounts: [],
          rejectedCounts: [],
          approvedCounts: [],
          approvedResidualCount: [],
          approveNewSubmission: [],
          pendingCounts: [],
          cancelledCounts: [],

          prevYear: {
            activeTotal: 0,
            inProcessTotal: 0,
            pendingTotal: 0,
          },

          thisYear: {
            activeCounts: [],
            inProcessCounts: [],
            pendingCounts: [],
            cancelledCounts: [],
            activeTotalCount: [],
          },
        },

        approved: {
          months: [],
          periodTotals: [],

          s1To15Counts: [],
          s16To66Counts: [],
          sOver3MonCounts: [],

          c1To15Counts: [],
          c16To66Counts: [],
          cOver3MonCounts: [],

          table: [],
        },
      },

      pla: {
        months: [],
        submittedCounts: [],
        approvedCounts: [],
        approvedResidualCount: [],
        approveNewSubmission: [],
        pendingCounts: [],
        rejectedCounts: [],
      },

      cenro: {
        months: [],
        submittedCounts: [],
        approvedCounts: [],
        approvedResidualCount: [],
        approveNewSubmission: [],
        pendingCounts: [],
        rejectedCounts: [],
      },

      plaSummary: {
        months: [],
        submittedCounts: [],
        approvedCounts: [],
        approvedResidualCount: [],
        approveNewSubmission: [],
        pendingCounts: [],
        rejectedCounts: [],
      },

      showCenroStats: false,
    };
  },
  getTargetPath() {
    return {
      name: this.$options.name,
      query: {
        activeTab: this.activeTabIndex,
      },
    };
  },
  syncValues(p, q) {
    const me = this;

    if ("activeTab" in q) {
      let index = parseInt(q.activeTab);
      if (!isNaN(index)) {
        me.activeTabIndex = index;
      }
    }
  },

  computed: {
    isCurrentYear() {
      return true;
      //  return this.yearId === this.currentYear;
    },

    isIvasApprovedSurveysOption() {
      return this.optionId > 1 && this.optionId < 6; // 2,3, or 4
    },
    isPLASubmittedSurveysOption() {
      return this.optionId > 1 && this.optionId < 6; // 2,3, or 4
    },

    isPlaOption() {
      return this.plaOptionId > 0; //> 4
    },

    approvedSurveysChartTitle() {
      if (this.optionId === 2) {
        return " Private Surveys";
      }
      if (this.optionId === 3) {
        return " Government Surveys";
      }
      if (this.optionId === 4) {
        return "DAR Regular Surveys";
      }
      if (this.optionId === 5) {
        return "DAR Split Surveys";
      }
      return "All Survey";
    },
  },

  methods: {
    getTargetPath() {
      const me = this,
        q = {};

      if (me.regionId) {
        q.regionId = me.regionId;
      }

      if (me.yearId) {
        q.yearId = me.yearId;
      }

      if (me.optionId) {
        q.optionId = me.optionId;
      }

      if (me.cenroOptionId) {
        q.cenroOptionId = me.cenroOptionId;
      }

      if (me.fieldOfficeId) {
        q.fieldOfficeId = me.fieldOfficeId;
      }

      return {
        name: me.$options.name,
        query: q,
      };
    },

    syncValues(p, q) {
      const me = this;

      me.regionName = "Unknown";
      me.fieldOfficeId = 0;
      me.fieldOfficeName = "Unknown";

      if ("regionId" in q) {
        me.regionId = parseInt(q.regionId);
        let region = me.regions.find((obj) => obj.regionId === me.regionId);
        if (region) {
          me.regionName = region.altName;
        }
      } else {
        me.regionId = 0;
      }

      if ("yearId" in q) {
        me.yearId = parseInt(q.yearId);
      } else {
        me.yearId = me.core.getCurrentYear();
      }

      if ("optionId" in q) {
        me.optionId = parseInt(q.optionId);
      } else {
        me.optionId = 1;
      }

      if ("cenroOptionId" in q) {
        me.cenroOptionId = parseInt(q.cenroOptionId);
      } else {
        me.cenroOptionId = "";
      }

      if ("fieldOfficeId" in q) {
        me.fieldOfficeId = parseInt(q.fieldOfficeId);
      } else {
        me.fieldOfficeId = 0;
      }
    },

    loadCenro(penroOfficeId) {
      const me = this;
      return get(
        "api/regions/" +
          me.regionId.toString() +
          "/" +
          penroOfficeId.toString() +
          "/cenroOffices"
      ).then(
        (offices) => {
          me.cenroOptions = offices;
        },

        (fault) => {
          me.showFault(fault);
        }
      );

      // return get("api/regions/" + me.regionId.toString() + "/offices").then(
      //   (offices) => {
      //     fieldOffices = offices;

      //     let plaOptions = [];
      //     let optionIndex = 0;

      //     fieldOffices.forEach((office) => {
      //       plaOptions.push({
      //         optionId: 6 + optionIndex,
      //         optionName: office.fieldOfficeName,
      //         fieldOfficeId: office.fieldOfficeId,
      //         penroTypeId: office.penroTypeId,
      //       });
      //       optionIndex = optionIndex + 1;
      //     });

      //     data.plaOptions = plaOptions;

      //     return Promise.resolve(data);
      //   },

      //   (fault) => {
      //     me.showFault(fault);
      //   }
      // );

      //       return get(
      //   "api/regions/" +
      //     me.regionId.toString() +
      //     "/" +
      //     penroOfficeId.toString() +
      //     "/cenroOffices"
      // ).then(
      //   (offices) => {
      //     me.cenroOptions = offices;

      //     let cenroList = [];
      //     let optionIndex = 0;

      //     me.cenroOptions.forEach((office) => {
      //       cenroList.push({
      //         cenroOptionId: 6 + optionIndex,
      //         optionName: office.fieldOfficeName,
      //         fieldOfficeId: office.fieldOfficeId,
      //         penroTypeId: office.penroTypeId,
      //       });
      //       optionIndex = optionIndex + 1;
      //     });
      //     console.log(me.cenroOptions);
      //     console.log(22222222);
      //     data.cenroOptions = me.cenroOptions;

      //     return Promise.resolve(data);
      //   },

      //   (fault) => {
      //     me.showFault(fault);
      //   }
      // );
    },

    loadData() {
      const me = this;

      me.loadDataIvasApprovedSurveys();
      me.loadDataPlaSummary();

      if (me.optionId === 1) {
        me.loadDataIvasSummary();
        return;
      }
      if (me.isIvasApprovedSurveysOption) {
        me.loadDataIvasApprovedSurveys();
        return;
      }

      if (me.isPlaOption) {
        me.loadDataPlaProduction();
        me.loadDataCenroProduction();

        return; //JYL
      }
    },

    loadDataIvasSummary() {
      const me = this,
        store = me.ivas.summary,
        wait = me.wait();

      me.getIvasSummary().then(
        (obj) => {
          me.stopWait(wait);

          let prevYear = {};

          try {
            prevYear.activeTotal = obj.prevYear[0].activeTotal;
            prevYear.inProcessTotal = obj.prevYear[0].inProcessTotal;
            prevYear.pendingTotal = obj.prevYear[0].pendingTotal;
          } catch (error) {
            prevYear.activeTotal = 0;
            prevYear.inProcessTotal = 0;
            prevYear.pendingTotal = 0;
          }

          let maxPeriodId = 12;
          if (me.yearId === me.currentYear) {
            maxPeriodId = 12; // TO SHOW ALL MONTHSme.core.getCurrentMonth();
          }

          let item,
            data = [];

          for (let index = 1; index <= maxPeriodId; index++) {
            item = obj.data.find((o) => o.periodId === index);
            if (item) {
              data.push(item);
            } else {
              data.push({
                periodId: index,
                submittedCount: 0,
                rejectedCount: 0,
                approvedCount: 0,
                approvedResidualCount: 0,
                approveNewSubmission: 0,
              });
            }
          }

          obj.data = data;

          let dataThisYear = [];

          for (let index = 1; index <= maxPeriodId; index++) {
            item = obj.dataThisYear.find((o) => o.periodId === index);
            if (item) {
              dataThisYear.push(item);
            } else {
              dataThisYear.push({
                periodId: index,
                activeCount: 0,
                inProcessCount: 0,
                pendingCount: 0,
                cancelledCount: 0,
                activeTotalCount: 0,
                approvedResidualCount: 0,
                approveNewSubmission: 0,
              });
            }
          }

          obj.dataThisYear = dataThisYear;

          store.months = obj.data.map((o) => me.getMonthName(o.periodId));
          store.submittedCounts = obj.data.map((o) => o.submittedCount);
          store.rejectedCounts = obj.data.map((o) => o.rejectedCount);
          store.approvedCounts = obj.data.map((o) => o.approvedCount);
          store.approvedResidualCount = data.map(
            (o) => o.approvedResidualCount
          );
          store.approveNewSubmission = data.map((o) => o.approveNewSubmission);
          store.pendingCounts = obj.data.map((o) => o.pendingCount);
          store.cancelledCounts = obj.data.map((o) => o.cancelledCount);
          store.prevYear = prevYear;
          store.thisYear.activeCounts = obj.dataThisYear.map(
            (o) => o.activeTotalCount
          );
          // store.thisYear.activeCounts = obj.dataThisYear.map( o => o.activeCount + o.activeTotalCount);
          store.thisYear.inProcessCounts = obj.dataThisYear.map(
            (o) => o.inProcessCount
          );
          store.thisYear.pendingCounts = obj.dataThisYear.map(
            (o) => o.pendingCount
          );
          store.thisYear.rejectedCounts = obj.dataThisYear.map(
            (o) => o.rejectedCount
          );
          store.thisYear.cancelledCounts = obj.dataThisYear.map(
            (o) => o.cancelledCount
          );
          me.drawCharts();
        },

        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
    },

    loadDataIvasApprovedSurveys() {
      const me = this,
        store = me.ivas.approved,
        wait = me.wait();

      me.getApprovedSurveys().then(
        (info) => {
          me.stopWait(wait);

          let maxPeriodId = 12;
          if (me.yearId === me.currentYear) {
            maxPeriodId = 12; // TO SHOW ALL MONTHS me.core.getCurrentMonth();
          }

          let item,
            data = [];

          for (let index = 1; index <= maxPeriodId; index++) {
            item = info.find((o) => o.periodId === index);
            if (item) {
              data.push(item);
            } else {
              data.push({
                periodId: index,
                s1To15Count: 0,
                s16To66Count: 0,
                sOver3MonCount: 0,
                c1To15Count: 0,
                c16To66Count: 0,
                cOver3MonCount: 0,
                periodTotal: 0,
              });
            }
          }

          store.table = data; // data for table section
          store.months = data.map((o) => me.getMonthName(o.periodId));
          store.periodTotals = data.map((o) => o.periodTotal);

          store.s1To15Counts = data.map((o) => o.s1To15Count);
          store.s16To66Counts = data.map((o) => o.s16To66Count);
          store.sOver3MonCounts = data.map((o) => o.sOver3MonCount);

          store.c1To15Counts = data.map((o) => o.c1To15Count);
          store.c16To66Counts = data.map((o) => o.c16To66Count);
          store.cOver3MonCounts = data.map((o) => o.cOver3MonCount);

          me.drawCharts();
        },

        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
    },

    loadDataPlaProduction() {
      const me = this,
        store = me.pla,
        wait = me.wait();

      let obj = me.plaOptions.find((o) => o.optionId === me.optionId);

      if (obj) {
        me.fieldOfficeId = obj.fieldOfficeId;
        me.fieldOfficeName = obj.optionName;

        // me.offTypeId = obj.offTypeId;
      }

      me.getPlaProduction().then(
        (info) => {
          me.stopWait(wait);

          let maxPeriodId = 12;
          if (me.yearId === me.currentYear) {
            maxPeriodId = 12; // TO SHOW ALL MONTHS me.core.getCurrentMonth();
          }

          let item,
            data = [];

          for (let index = 1; index <= maxPeriodId; index++) {
            item = info.find((o) => o.periodId === index);
            if (item) {
              data.push(item);
            } else {
              data.push({
                periodId: index,
                submittedCount: 0,
                approvedCount: 0,
                approvedResidualCount: 0,
                approveNewSubmissionCount: 0,
              });
            }
          }

          store.table = data; // data for table section
          store.months = data.map((o) => me.getMonthName(o.periodId));
          store.submittedCounts = data.map((o) => o.submittedCount);
          store.approvedCounts = data.map((o) => o.approvedCount);

          store.approveNewSubmission = data.map(
            (o) => o.approveNewSubmissionCount
          );
          store.approvedResidualCount = data.map(
            (o) => o.approvedResidualCount
          );
          store.rejectedCounts = data.map((o) => o.rejectedCount);
          store.pendingCounts = data.map((o) => o.pendingCount);
          store.cancelledCounts = data.map((o) => o.cancelledCount);

          me.drawCharts();
        },

        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
    },

    //JYL

    loadDataCenroProduction() {
      const me = this,
        store = me.cenro,
        wait = me.wait();

      let obj = me.cenroOptions.find(
        (o) => o.cenroOfficeId === me.cenroOfficeId
      );

      if (obj) {
        me.fieldOfficeId = obj.fieldOfficeId;
        // me.fieldOfficeName = obj.optionName;
        me.cenroOfficeName = obj.fieldOfficeName;

        // me.offTypeId = obj.offTypeId;
      }

      // Cenro

      me.getCenroProduction().then(
        (info) => {
          me.stopWait(wait);

          let maxPeriodId = 12;
          if (me.yearId === me.currentYear) {
            maxPeriodId = 12; // TO SHOW ALL MONTHS me.core.getCurrentMonth();
          }

          let item,
            data = [];

          for (let index = 1; index <= maxPeriodId; index++) {
            item = info.find((o) => o.periodId === index);
            if (item) {
              data.push(item);
            } else {
              data.push({
                periodId: index,
                submittedCount: 0,
                approvedCount: 0,
                approvedResidualCount: 0,
                approveNewSubmissionCount: 0,
              });
            }
          }

          store.table = data; // data for table section
          store.months = data.map((o) => me.getMonthName(o.periodId));
          store.submittedCounts = data.map((o) => o.submittedCount);
          store.approvedCounts = data.map((o) => o.approvedCount);

          store.approveNewSubmission = data.map(
            (o) => o.approveNewSubmissionCount
          );
          store.approvedResidualCount = data.map(
            (o) => o.approvedResidualCount
          );
          store.rejectedCounts = data.map((o) => o.rejectedCount);
          store.pendingCounts = data.map((o) => o.pendingCount);
          store.cancelledCounts = data.map((o) => o.cancelledCount);

          me.drawCharts();
        },

        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
    },

    loadDataPlaSummary() {
      const me = this,
        store = me.plaSummary,
        wait = me.wait();

      me.getPlaSummary().then(
        (info) => {
          me.stopWait(wait);
          // console.log(info);
          let maxPeriodId = 12;
          if (me.yearId === me.currentYear) {
            maxPeriodId = 12; // TO SHOW ALL MONTHS me.core.getCurrentMonth();
          }

          let item,
            data = [];

          for (let index = 1; index <= maxPeriodId; index++) {
            item = info.find((o) => o.periodId === index);
            if (item) {
              data.push(item);
            } else {
              data.push({
                periodId: index,
                submittedCount: 0,
                approvedCount: 0,
                approvedResidualCount: 0,
                approveNewSubmissionCount: 0,
              });
            }
          }

          store.table = data; // data for table section
          store.months = data.map((o) => me.getMonthName(o.periodId));
          store.submittedCounts = data.map((o) => o.submittedCount);
          store.approvedCounts = data.map((o) => o.approvedCount);

          store.approveNewSubmission = data.map(
            (o) => o.approveNewSubmissionCount
          );
          store.approvedResidualCount = data.map(
            (o) => o.approvedResidualCount
          );
          store.rejectedCounts = data.map((o) => o.rejectedCount);
          store.pendingCounts = data.map((o) => o.pendingCount);
          store.cancelledCounts = data.map((o) => o.cancelledCount);

          me.drawCharts();
        },

        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
    },

    // API Calls

    getOptions() {
      const me = this;
      // wait = me.wait();

      let fieldOffices = [],
        data = {
          ivasOptions: [
            { optionId: 1, optionName: "Summary", fieldOfficeId: 0 },
            {
              optionId: 3,
              optionName: "Government  Surveys",
              fieldOfficeId: 0,
            },

            { optionId: 2, optionName: "Private Surveys", fieldOfficeId: 0 },
            {
              optionId: 4,
              optionName: "DAR Regular Surveys",
              fieldOfficeId: 0,
            },
            { optionId: 5, optionName: "DAR-SPLIT Surveys", fieldOfficeId: 0 },
          ],

          PLAOptions: [
            { plaOptionId: 1, optionName: "Summary", fieldOfficeId: 0 },
            {
              plaOptionId: 2,
              optionName: "Residential",
              fieldOfficeId: 0,
            },

            { plaOptionId: 3, optionName: "Agricultural", fieldOfficeId: 0 },
            {
              plaOptionId: 4,
              optionName: "Foreshore Lease",
              fieldOfficeId: 0,
            },
          ],
        };

      return get("api/regions/" + me.regionId.toString() + "/offices").then(
        (offices) => {
          fieldOffices = offices;

          let plaOptions = [];
          let optionIndex = 0;

          fieldOffices.forEach((office) => {
            plaOptions.push({
              optionId: 6 + optionIndex,
              optionName: office.fieldOfficeName,
              fieldOfficeId: office.fieldOfficeId,
              penroTypeId: office.penroTypeId,
            });
            optionIndex = optionIndex + 1;
          });

          data.plaOptions = plaOptions;

          return Promise.resolve(data);
        },

        (fault) => {
          me.showFault(fault);
        }
      );
    },

    onActiveTabIndexChanged() {
      const me = this;
      // Reload
      me.optionId = 1;
      me.plaOptionId = 1;
      // this.loadData();
      //this.drawCharts();
      me.reload();
      me.showCenroFlag = false;
      me.showPenroStats = false;
    },

    getIvasSummary() {
      const me = this;

      let query =
        "regionId=" +
        me.regionId.toString() +
        "&yearId=" +
        me.yearId.toString();
      return get("api/stats/surveys-summary?" + query);
    },

    getApprovedSurveys() {
      const me = this;
      // if (!me.isIvasApprovedSurveysOption) {
      // return Promise.resolve([]);
      // }
      let query =
        "regionId=" +
        me.regionId.toString() +
        "&yearId=" +
        me.yearId.toString();

      //   if (me.optionId === 3) {
      //   query = query + "&surveyTypeId=1"; // all Survey
      // }

      if (me.optionId === 4) {
        query = query + "&surveyTypeId=2"; // DAR Project
      }
      if (me.optionId === 5) {
        query = query + "&surveyTypeId=3"; // DAR Split Survey
      }
      if (me.optionId === 3) {
        query = query + "&surveyTypeId=4"; // Government Survey
      }
      if (me.optionId === 2) {
        query = query + "&surveyTypeId=5"; // Private Survey
      }
      return get("api/stats/surveys-approved?" + query);
    },

    getPlaProduction() {
      const me = this;

      let query =
        "regionId=" +
        me.regionId.toString() +
        "&fieldOfficeId=" +
        me.fieldOfficeId.toString() +
        "&yearId=" +
        me.yearId.toString();
      //    return get("api/stats/applications?" + query);

      // let query =
      //   "regionId=" +
      //   me.regionId.toString() +
      //   "&yearId=" +
      //   me.yearId.toString() +
      //     "fieldOfficeId=" +
      //   me.fieldOfficeId.toString() ;

      if (me.plaOptionId === 2) {
        query = query + "&applicationTypeId='RFP'"; // Residential
      }
      if (me.plaOptionId === 3) {
        query = query + "&applicationTypeId='FPA'"; // Agricultural
      }
      if (me.plaOptionId === 4) {
        query = query + "&applicationTypeId='FAM'"; // Foreshore Lease
      }

      return get("api/stats/plas-application?" + query);
    },

    getCenroProduction() {
      const me = this;

      let query =
        "regionId=" +
        me.regionId.toString() +
        "&fieldOfficeId=" +
        me.cenroOfficeId.toString() +
        "&yearId=" +
        me.yearId.toString();

      if (me.plaOptionId === 2) {
        query = query + "&applicationTypeId='RFP'"; // Residential
      }
      if (me.plaOptionId === 3) {
        query = query + "&applicationTypeId='FPA'"; // Agricultural
      }
      if (me.plaOptionId === 4) {
        query = query + "&applicationTypeId='FAM'"; // Foreshore Lease
      }

      return get("api/stats/plas-cenro-application?" + query);
    },

    getPlaSummary() {
      const me = this;

      let query =
        "regionId=" +
        me.regionId.toString() +
        "&fieldOfficeId=" +
        me.cenroOfficeId.toString() +
        "&yearId=" +
        me.yearId.toString();

      return get("api/stats/plas-application-summary?" + query);
    },

    // event handlers

    onRegionIdChanged() {
      const me = this;

      me.getOptions()
        .then((data) => {
          me.ivasOptions = data.ivasOptions;
          me.plaOptions = data.plaOptions;
          me.PLAOptions = data.PLAOptions;

          me.fieldOfficeId = 0;
          me.fieldOfficeName = "";

          if (me.optionId > 4 && !me.plaOptions.length) {
            me.optionId = 1;
          }
        })
        .then(() => {
          me.reload();
        })
        .catch((fault) => {
          me.showFault(fault);
        });
    },

    onYearIdChanged() {
      this.reload();
    },

    onOptionIdChanged() {
      const me = this;
      let obj;
      me.cenroOfficeId = 0; //yan yung nagreset
      if (me.isPlaOption) {
        obj = me.plaOptions.find((o) => o.optionId === me.optionId);

        me.loadData();
      }
      if (obj) {
        me.fieldOfficeId = obj.fieldOfficeId;
        me.fieldOfficeName = obj.optionName;
        me.penroTypeId = obj.penroTypeId;
        // console.log(me.penroTypeId);

        if (me.penroTypeId == "I") {
          me.showCenroFlag = false;
        } else {
          me.showCenroFlag = true;
          me.loadCenro(me.fieldOfficeId);
        }

        if (me.fieldOfficeId == "") {
          me.showPenroStats = false;
        } else {
          me.showPenroStats = true;
          // me.loadCenro(me.fieldOfficeId);
        }
      } else {
        me.fieldOfficeId = 0;
        me.fieldOfficeName = "";
      }
      // if (obj.optionName === "") {
      //   this.isShowFilter = false;
      // } else {
      //   this.isShowFilter = true;
      // }
      me.reload();
    },

    onCenroOptionIdChanged() {
      const me = this;
      let obj;
      // 'PIOLO'
      //  console.log(me.cenroOfficeId);
      // console.log(me.cenroOptions);

      if (me.isPlaOption) {
        obj = me.cenroOptions.find((o) => o.cenroOfficeId === me.cenroOfficeId);
        // console.log(me.cenroOptionId);
        me.loadData();
      }

      if (obj) {
        me.cenroOfficeId = obj.cenroOfficeId;
      } else {
        me.cenroOfficeId = 0;
        me.fieldOfficeName = "";
      }

      me.reload();
    },

    onResize() {
      this.drawCharts();
    },

    onPrint() {
      window.print();
    },

    // helpers

    drawChartIvasSummary() {
      const me = this;

      //   const mq = window.matchMedia("(max-width: 600px)");
      //   let aspectRatio = 1.4;
      //   if (mq.matches) {
      //     aspectRatio = 1.2;
      //   }

      let chartData = {
        labels: me.ivas.summary.months,

        datasets: [
          {
            label: "Submitted",
            data: me.ivas.summary.submittedCounts,
            backgroundColor: "#fbbe0b",
          },

          {
            label: "Approved",
            data: me.ivas.summary.approvedCounts,
            backgroundColor: "#507cc4",
          },
          {
            label: "Rejected",
            data: me.ivas.summary.rejectedCounts,
            backgroundColor: "#c45850",
          },

          {
            label: "In-Process",
            data: me.ivas.summary.thisYear.inProcessCounts,
            // backgroundColor: "violet",
            backgroundColor: "#5A9367",
          },
        ],
      };

      let options = {
        scales: {
          y: {
            beginAtZero: true,
          },
        },

        plugins: {
          title: {
            display: true,
            text: "IVAS Summary " + me.yearId,
            font: {
              size: 20,
              lineHeight: 0.5,
            },
          },

          subtitle: {
            display: true,
            text: me.regionName,
            font: {
              size: 18,
            },
            padding: {
              bottom: 0,
            },
          },

          legend: {
            labels: {
              boxWidth: 20,
            },
          },
        },

        aspectRatio: document.body.clientWidth > 780 ? 2.8 : 1.4,
        // maintainAspectRatio: false
        resizeDelay: 800,
      };

      let chart = drawBarChart("ivas-summary-chart", chartData, options);
      this.charts.push(chart);
    },
    drawChartIvasApprovedSurveys(chartId, isSimple = true) {
      const me = this,
        store = me.ivas.approved;

      let chartData = {
        labels: store.months,

        datasets: [
          {
            label: "1-20",
            data: isSimple ? store.s1To15Counts : store.c1To15Counts,
            backgroundColor: "#3cba9f",
          },

          {
            label: "21-40",
            data: isSimple ? store.s16To66Counts : store.c16To66Counts,
            backgroundColor: "#505bc4",
          },

          {
            label: "> 40 days",
            data: isSimple ? store.sOver3MonCounts : store.cOver3MonCounts,
            backgroundColor: "#c45050",
          },
        ],
      };

      let options = {
        scales: {
          y: {
            beginAtZero: true,
          },
        },

        plugins: {
          title: {
            display: true,
            text: isSimple ? "Simple" : "Complex",
            font: {
              size: 20,
              lineHeight: 0.5,
            },
          },

          legend: {
            labels: {
              boxWidth: 20,
            },
          },
        },

        aspectRatio: document.body.clientWidth > 780 ? 2.4 : 1.8,
        // maintainAspectRatio: false
        resizeDelay: 800,
      };

      let chart = drawBarChart(chartId, chartData, options);
      this.charts.push(chart);
    },

    drawChartPlaSummary() {
      const me = this;

      let chartData = {
        labels: me.plaSummary.months,

        datasets: [
          {
            label: "Submitted",
            data: me.plaSummary.submittedCounts,
            backgroundColor: "#fbbe0b",
          },

          {
            label: "Approved",
            data: me.plaSummary.approvedCounts,
            backgroundColor: "#507cc4",
          },
        ],
      };

      let options = {
        scales: {
          y: {
            beginAtZero: true,
          },
        },

        plugins: {
          title: {
            display: true,
            text: "Regional  Summary " + me.yearId,
            font: {
              size: 20,
              lineHeight: 0.9,
            },
          },

          subtitle: {
            display: true,
            text: me.regionName,
            font: {
              size: 18,
            },
            padding: {
              bottom: 0,
            },
          },

          legend: {
            labels: {
              boxWidth: 20,
            },
          },
        },

        aspectRatio: document.body.clientWidth > 780 ? 2.8 : 1.4,
        // maintainAspectRatio: false
        resizeDelay: 800,
      };

      let chart = drawBarChart("pla-summary-chart", chartData, options);
      this.charts.push(chart);
    },

    drawChartPlaProduction() {
      const me = this;

      let chartData = {
        labels: me.pla.months,

        datasets: [
          {
            label: "Submitted",
            data: me.pla.submittedCounts,
            // backgroundColor: "#fbbe0b", //"#3cba9f",
            backgroundColor: "rgb(251, 190, 11 , .4)",
            borderColor: "#fbbe0b",
            borderWidth: 2,
            //  pointBackgroundColor: '#28a745',
            pointBackgroundColor: "#fefefe",

            fill: true,
            opacity: 0.2,
            tension: 0.6,
          },

          {
            label: "Approved",
            data: me.pla.approvedCounts,
            // backgroundColor: "#507cc4",
            backgroundColor: "rgb(80, 124, 196, .4)",
            borderColor: "#507cc4",
            borderWidth: 2,
            //       // pointBackgroundColor: '#28a745',
            pointBackgroundColor: "#fefefe",
            fill: true,
            tension: 0.6,
          },
        ],
      };

      let options = {
        scales: {
          y: {
            beginAtZero: true,
          },
        },

        plugins: {
          title: {
            display: true,
            text: "Province Summary " + me.yearId,
            font: {
              size: 20,
              lineHeight: 0.9,
            },
          },

          subtitle: {
            display: true,
            text: me.fieldOfficeName,
            font: {
              size: 18,
            },
            padding: {
              bottom: 0,
            },
          },

          legend: {
            labels: {
              boxWidth: 20,
            },
          },
        },

        aspectRatio: document.body.clientWidth > 780 ? 2.8 : 1.4,
        // maintainAspectRatio: false
        resizeDelay: 800,
      };

      let chart = drawLineChart("pla-chart", chartData, options);
      this.charts.push(chart);
    },

    //JYL

    drawChartCenroProduction() {
      const me = this;

      let chartData = {
        labels: me.cenro.months,

        datasets: [
          {
            label: "Submitted",
            data: me.cenro.submittedCounts,
            // backgroundColor: "#fbbe0b", //"#3cba9f",
            backgroundColor: "rgb(251, 190, 11 , .4)",
            borderColor: "#fbbe0b",
            borderWidth: 2,
            //  pointBackgroundColor: '#28a745',
            pointBackgroundColor: "#fefefe",

            fill: true,
            opacity: 0.2,
            tension: 0.6,
          },

          {
            label: "Approved",
            data: me.cenro.approvedCounts,
            // backgroundColor: "#507cc4",
            backgroundColor: "rgb(80, 124, 196, .4)",
            borderColor: "#507cc4",
            borderWidth: 2,
            //       // pointBackgroundColor: '#28a745',
            pointBackgroundColor: "#fefefe",
            fill: true,
            tension: 0.6,
          },
        ],
      };

      let options = {
        scales: {
          y: {
            beginAtZero: true,
          },
        },

        plugins: {
          title: {
            display: true,
            text: "Status of Cenro " + me.yearId,
            font: {
              size: 20,
              lineHeight: 0.9,
            },
          },

          subtitle: {
            display: true,
            text: me.cenroOfficeName,
            font: {
              size: 18,
            },
            padding: {
              bottom: 0,
            },
          },

          legend: {
            labels: {
              boxWidth: 20,
            },
          },
        },

        aspectRatio: document.body.clientWidth > 780 ? 2.8 : 1.4,
        // maintainAspectRatio: false
        resizeDelay: 800,
      };

      let chart1 = drawLineChart("cenro-chart", chartData, options);
      this.charts.push(chart1);
    },
    // drawChartPlaSummaryProduction() {
    //   const me = this;

    //   let chartData = {
    //     labels: me.pla.summary.months,

    //     datasets: [
    //       {
    //         label: "Submitted",
    //         data: me.pla.summary.submittedCounts,
    //         backgroundColor: "rgb(90, 147, 103, .4)",
    //         borderColor: "#5A9367",
    //         borderWidth: 2,
    //         //  pointBackgroundColor: '#28a745',
    //         pointBackgroundColor: "#5A9367",

    //         fill: true,
    //         opacity: 0.2,
    //         tension: 0.6,
    //       },

    //       {
    //         label: "Approved",
    //         data: me.pla.summary.approvedCounts,
    //         backgroundColor: "rgb(196, 88, 80, .4)",
    //         borderColor: "#c45050",
    //         borderWidth: 2,
    //         //  pointBackgroundColor: '#28a745',
    //         pointBackgroundColor: "#c45050",

    //         fill: true,
    //         opacity: 0.2,
    //         tension: 0.6,
    //       },
    //     ],
    //   };

    //   let options = {
    //     scales: {
    //       y: {
    //         beginAtZero: true,
    //       },
    //     },

    //     plugins: {
    //       title: {
    //         display: true,
    //         text: "Province Summary " + me.yearId,
    //         font: {
    //           size: 20,
    //           lineHeight: 0.9,
    //         },
    //       },

    //       subtitle: {
    //         display: true,
    //         text: me.fieldOfficeName,
    //         font: {
    //           size: 18,
    //         },
    //         padding: {
    //           bottom: 0,
    //         },
    //       },

    //       legend: {
    //         labels: {
    //           boxWidth: 20,
    //         },
    //       },
    //     },

    //     aspectRatio: document.body.clientWidth > 780 ? 2.8 : 1.4,
    //     // maintainAspectRatio: false
    //     resizeDelay: 800,
    //   };

    //   let chart = drawLineChart("pla-summary-chart", chartData, options);
    //   this.charts.push(chart);
    // },

    // drawSummaryChart() {
    //   const me = this;

    //   let chartData = {
    //     labels: me.summaryYears,

    //     datasets: [
    //       {
    //         label: "Submitted",
    //         data: me.submittedCounts,
    //         // backgroundColor: "#fbbe0b", //"#3cba9f",
    //         backgroundColor: "rgb(251, 190, 11 , .4)",
    //         borderColor: "#fbbe0b",
    //         borderWidth: 2,
    //         //  pointBackgroundColor: '#28a745',
    //         pointBackgroundColor: "#fefefe",

    //         fill: true,
    //         opacity: 0.2,
    //         tension: 0.6,
    //       },

    //       {
    //         label: "Approved",
    //         data: me.approvedCounts,
    //         // backgroundColor: "#507cc4",
    //         backgroundColor: "rgb(80, 124, 196, .4)",
    //         borderColor: "#507cc4",
    //         borderWidth: 2,
    //         //       // pointBackgroundColor: '#28a745',
    //         pointBackgroundColor: "#fefefe",
    //         fill: true,
    //         tension: 0.6,
    //       },

    //     ],

    //   };

    //   let options = {
    //     scales: {
    //       y: {
    //         beginAtZero: true,
    //       },
    //     },

    //     plugins: {
    //       title: {
    //         display: true,
    //         text: " Transaction Status",
    //         font: {
    //           size: 19,
    //           lineHeight: 1,
    //         },
    //         padding: {
    //           top: 10,
    //         },
    //       },

    //       legend: {
    //         labels: {
    //           boxWidth: 20,
    //         },
    //       },
    //     },

    //     aspectRatio: 1.4,
    //   };

    //   let chart = drawLineChart("annual-summary-chart", chartData, options);
    //   this.charts.push(chart);
    // },
    drawCharts() {
      const me = this;

      me.charts.forEach((chart) => {
        chart.destroy();
        chart = null;
      });
      me.drawChartPlaSummary();
      me.drawChartIvasSummary();

      if (me.optionId === 1) {
        me.drawChartIvasApprovedSurveys("simple-survey-chart");
        me.drawChartIvasApprovedSurveys("complex-survey-chart", false);
        return;
      }

      if (me.isIvasApprovedSurveysOption) {
        me.drawChartIvasApprovedSurveys("simple-survey-chart1");
        me.drawChartIvasApprovedSurveys("complex-survey-chart1", false);
        return;
      }

      if (me.isPlaOption) {
        me.showCenroStats = false;

        me.drawChartPlaProduction();
        // me.drawChartPlaSummaryProduction();

        if (!me.penroTypeId == "I" || !me.cenroOfficeId == 0) {
          me.showCenroStats = true;
          me.drawChartCenroProduction();
          return;
        }
      }
      // if (me.plaOptionId === 1) {

      // }

      if (me.plaOptionId > 4) {
        me.showCenroFlag = false;
      }
    },

    getStatsPagePath() {
      return this.sym.getPath("lms3010") + "?regionId=" + this.regionId;
    },

    getMonthName(periodId, longFormat = false) {
      return longFormat
        ? this.longMonthNames[periodId]
        : this.shortMonthNames[periodId];
    },
  },

  mounted() {
    const me = this;

    me.dom.on(window, "resize", me.onResize);

    me.currentYear = me.core.getCurrentYear();
    me.prevYear = me.currentYear - 1;
    me.regions = lams.getRegionList();
    me.detailYears = lams.getYearsDatasource();

    me.syncValues(me.params, me.query);

    me.getOptions()
      .then((data) => {
        me.ivasOptions = data.ivasOptions;
        me.plaOptions = data.plaOptions;
        me.PLAOptions = data.PLAOptions;
      })
      .then(() => {
        me.loadData();
      })
      .catch((fault) => {
        me.showFault(fault);
      });
    //123//
    // me.plaOptions = lams.getPlaOptions().slice(0);
    // me.plaOptions.unshift({
    //   optionId: 0,
    //   optionName: "--- Select Field Office ---",
    // });
  },

  created() {
    const me = this;

    me.shortMonthNames = me.core.getMonthNames();
    me.longMonthNames = me.core.getMonthNames("long");
  },

  beforeDestroy() {
    this.dom.off(window, "resize", this.onResize);
  },

  beforeRouteUpdate(to, from, next) {
    this.syncValues(to.params, to.query);
    next();

    if (Object.keys(from.query).length) {
      this.loadData();
    }
  },
};
</script>

<style>
@media print {
  body * {
    visibility: hidden;
  }
}
</style>

<style scoped>
@media print {
  .to-print,
  .to-print * {
    visibility: visible;
  }

  .to-print {
    position: absolute;
    left: 0;
    top: 0;
  }

  canvas.chart-canvas {
    min-height: 100%;
    max-width: 100%;
    max-height: 100%;
    height: auto !important;
    width: auto !important;
  }
}

.lms3020-container {
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
  padding-bottom: 3rem;
}

.lms3020 {
  width: 80%;
  padding: 1rem 2rem;
  border-radius: 0.375rem;
}

.reg-stat-title,
.reg-analytics-title {
  font-size: 1.125rem;
  margin-bottom: 0;
  padding-left: 0.125rem;
}

.reg-stat {
  display: flex;
}

.reg-stat >>> .form-control {
  margin-bottom: 0;
}

.chart-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
  grid-auto-flow: dense;
}
.chart-container-pla-summary,
.chart-container-ivas-summary,
.chart-container-pla-production {
  width: 65%;
}
.chart-container-pla-summary-production {
  width: 100%;
}
.control-container {
  display: flex;
}
.Pla-container {
  display: flex;
  margin-top: 10px;
}

.year-control {
  margin-left: 0.5rem;
}

/* .table-scroll-ivas-summary,
.table-scroll-ivas-approved,
.table-scroll-pla-production */
.table-scroll-ivas-summary,
.table-scroll-ivas-approved,
.table-scroll-pla-production,
.table-scroll-pla-summary {
  overflow-x: auto;
  white-space: nowrap;
  table-layout: unset;
}
/* .table-scroll-pla-summary-wrapper {
  width: 100%;
} */
.table-scroll-ivas-summary-wrapper {
  overflow: auto;
}
/* .table-scroll-ivas-summary {
  width: 150vw;
} */
.header {
  height: 100%;
}
.filter {
  display: flex;
  flex-direction: column;
  /* justify-content: ; */
  flex-wrap: wrap;
}
.date-container {
  display: flex;
  justify-content: flex-end;
}
.date-picker {
  width: 22%;
  margin-right: 10px;
}
@media only screen and (max-width: 1024px) {
  .lms3020 {
    width: 90%;
    padding: 2rem;
  }
}

@media only screen and (max-width: 800px) {
  .lms3020 {
    width: 100%;
    padding: 1rem;
    border-radius: 0;
  }

  .lms3020-container {
    padding-bottom: 0;
  }
}

@media only screen and (max-width: 700px) {
  .reg-stat {
    display: block;
  }

  .control-container {
    margin-bottom: 0.25rem;
  }

  .chart-container {
    display: block;
  }
}

@media only screen and (max-width: 650px) {
  .table-scroll-ivas-summary {
    display: block;
  }

  .table-scroll-pla-production {
    display: block;
  }
}

@media only screen and (max-width: 576px) {
  #ivas-combo >>> .radios {
    flex-direction: column !important;
  }
  #PLA-combo >>> .radios {
    flex-direction: column !important;
  }

  .table-scroll-ivas-approved {
    display: block;
  }

  .chart-container-ivas-summary,
  .chart-container-pla-production {
    width: 100%;
  }
  /* .chart-container-pla-summary {
    width: 100%;
  } */
}

@media only screen and (max-width: 560px) {
  .lms3020-container {
    padding-top: 0;
    padding-bottom: 1rem;
  }

  .reg-stat-title,
  .reg-analytics-title {
    font-size: 1rem;
  }

  .reg-stat-title {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .region-map {
    display: none !important;
  }

  .reg-stat >>> .form-control {
    margin-bottom: 0.25rem;
  }

  .control-container {
    display: block;
    margin-bottom: 0;
  }

  .year-control {
    margin-left: 0;
  }
}

@media only screen and (max-width: 420px) {
  .lms3020 {
    padding: 0.5rem;
  }
}
</style>
